module.exports = "/_next/static/images/clock-16f4775659b8ef22228e30f78b46eb6f.svg";